import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { get } from 'lodash';
import { useQuery } from 'react-query';
import { useSelector } from 'react-redux';
import { Field, Form, reduxForm } from 'redux-form/immutable';
import { apiResponseWrapper } from 'utils/apiResponseWrapper';
import * as parsers from 'utils/reduxForm/parsers';
import moment from 'utils/moment';
import { isRequiredFn } from 'modules/Taps/utils/validations/numberFieldValidations';
import getContactInfo from 'modules/Profile/services/API/getPersonalData';
import PersonalInfoGP3Container from 'modules/Taps/containers/PersonalInfoGP3Container';
import personalInfoFields from 'modules/Taps/components/PersonalInfoGP3/fieldsConfig';
import renderDateField from 'components/DateField/reduxFormDateField';
import RelativeLoading from 'components/Loading/RelativeLoading';
import renderCheckboxField from 'components/Checkbox/reduxForm';
import renderField from 'components/Field/reduxForm';
import Button from 'components/Button';
import Card from 'components/Card/CardNew';

const formName = 'mobilizationReportForm';

function MobilizationReportForm(props) {
  const { handleSubmit, autofill } = props;

  const { isFetching, data: contactInfo } = useQuery('getContactInfo', async () => {
    return apiResponseWrapper(await getContactInfo());
  });

  const [checked, setChecked] = useState(false);

  const isArmyMobilized = useSelector((state) => {
    const profile = get(state, 'app.user', Map);
    const profileData = profile.get('data');
    return profileData.get('isArmyMobilized');
  });

  if (isFetching) {
    return <RelativeLoading />;
  }

  if (
    (contactInfo && contactInfo?.gender === '2') ||
    moment().diff(contactInfo?.dateOfBirth, 'year') < 18 ||
    isArmyMobilized
  ) {
    return (
      <div className={'boo'}>
        <Card className={'mt-3 mb-3 p-3'}>
          <div>Нет доступа к форме.</div>
        </Card>
      </div>
    );
  }

  let view = <></>;
  if (isArmyMobilized === false) {
    view = (
      <Form onSubmit={handleSubmit}>
        <div>
          <div className={'H2 pt-3 pb-3'}>Сообщить о факте мобилизации</div>

          <div className="white-block white-block__pad40 page_margin30 white-block_banner">
            <div className="link link_attention">
              Призванные в рамках частичной мобилизации граждане могут рассчитывать на меры
              налоговой поддержки. Полный перечень{' '}
              <a href="https://www.nalog.gov.ru/rn77/mobilization/">тут</a>. По сведениям от
              Министерства обороны РФ Вы не мобилизованы. Если это не так, сообщите об этом,
              пожалуйста.
            </div>
          </div>

          <Card className={'mt-3 mb-3 p-3'}>
            <PersonalInfoGP3Container
              autofill={autofill}
              needAutofill={true}
              fields={[
                personalInfoFields.inn,
                personalInfoFields.lastName,
                personalInfoFields.firstName,
                personalInfoFields.middleName,
              ]}
              parentFormName={formName}
              showRequiredMessage={false}
              isOpen={false}
            />

            <Field
              component={renderCheckboxField}
              value={checked}
              name={'isMobilizationConfirmed'}
              label="Подтверждаю, что являюсь мобилизованным"
              onChange={() => setChecked(!checked)}
              validate={isRequiredFn}
            />
            <Field
              minDate={moment.fromServerDatetime('2022-02-24')}
              maxDate={moment()}
              label={'Дата мобилизации *'}
              name={'mobilizationDate'}
              component={renderDateField}
              validate={isRequiredFn}
              parse={parsers.momentParser}
            />
            <Field
              label="Серия и номер военного билета"
              name="militaryId"
              component={renderField}
              placeholder="ББ XXXXXX0"
              normalize={(val, prevVal) => {
                let normalizedValue = val.toUpperCase() || '';
                if (normalizedValue.length > 10) {
                  return prevVal;
                }
                if (normalizedValue.length > 2 && normalizedValue[2] !== ' ') {
                  const letters = normalizedValue.substring(0, 2);
                  const numbers = normalizedValue.substring(2, normalizedValue.length);
                  normalizedValue = `${letters} ${numbers}`;
                }
                return normalizedValue;
              }}
              validate={(val) => {
                if (val && !val.match(/^[А-Я]{2} \d{6,7}$/)) {
                  return 'Серия и номер военного билета должны быть в формате ББ XXXXXX0 (где Б - любая заглавная буква кириллицы, Х - обязательная цифра, 0 - необязательная цифра)';
                }
                return null;
              }}
            />

            <Button type={'submit'} isDisabled={!checked}>
              Отправить
            </Button>
          </Card>
        </div>
      </Form>
    );
  }

  return view;
}

export default reduxForm({
  form: formName,
})(MobilizationReportForm);

MobilizationReportForm.propTypes = {
  handleSubmit: PropTypes.func,
  autofill: PropTypes.func.isRequired,
};
